// extracted by mini-css-extract-plugin
module.exports = {"base":"termsAndConditions_base__3nrot","termsCheckbox":"termsAndConditions_termsCheckbox__2Kem2"};